import {
  CLERK_HOSTED_DOMAIN,
  GOOGLE_SIGN_IN_HOST,
} from "~/feature/attribution/constants";

export const toHostname = (url: string): string | null => {
  try {
    return new URL(url).hostname || null;
  } catch {
    return null;
  }
};

const isSameOrSubdomain = (host: string, domain: string): boolean =>
  host === domain || host.endsWith(`.${domain}`);

const isGoogleSignIn = (host: string): boolean => host === GOOGLE_SIGN_IN_HOST;

const isClerkHosted = (host: string): boolean =>
  isSameOrSubdomain(host, CLERK_HOSTED_DOMAIN);

const isOwnHost = (host: string, ownHosts: string[]): boolean =>
  ownHosts.some((ownHost) => isSameOrSubdomain(host, ownHost));

const isExcludedReferrer = (host: string, ownHosts: string[]): boolean =>
  isGoogleSignIn(host) || isClerkHosted(host) || isOwnHost(host, ownHosts);

export const readReferrerDomain = (
  referrer: string,
  ownHosts: string[]
): string | null => {
  const host = toHostname(referrer);

  if (!host || isExcludedReferrer(host, ownHosts)) {
    return null;
  }

  return host;
};
